"use client";

import styled from "styled-components";
import { TableHead } from "../ui/table";

export const HeaderTable = styled(TableHead)`
  button {
    padding: 0;
    cursor: pointer;

    &:hover {
      background: transparent;
    }
  }
`;

export const FooterTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const FirstBoxFooter = styled.div`
  flex: 1;
  font-size: 0.875rem;
  color: var(--muted-foreground);
`;

export const PaginationBox = styled.div`
  display: flex;
  gap: 0.5rem;
`;
